import * as React from 'react';
import { Dropdown, DropdownMenuItemType } from '@fluentui/react/lib/Dropdown';
import AsyncSelect from 'react-select/async';
import { throwError, summaryScreen, toggleLoading, clearError } from '../actions/navigationWorker';
import { get_choice_field_dependence, entity_quick_search } from '../actions/entityWorker';
import { GetSetting } from '../actions/settingsWorker';
import { GetItemText } from '../actions/helper';
import { TextField } from '@fluentui/react/lib/TextField';
import { Label } from '@fluentui/react/lib/Label';

let task_types = [{ key: 'Header', text: 'Task Type', itemType: DropdownMenuItemType.Header }];
let task_subtypes = [{ key: 'Header', text: 'Task Subtype', itemType: DropdownMenuItemType.Header }];
let task_status = [{ key: 'Header', text: 'Task Status', itemType: DropdownMenuItemType.Header }];
const group_name = 'task';

// Responsive dropdown configuration for better mobile UX
const responsiveDropdownProps = {
	calloutProps: { 
		calloutMaxHeight: 400,
		doNotLayer: false,
		calloutMinWidth: 300,
		preventDismissOnScroll: false,
		preventDismissOnResize: false,
		preventDismissOnLostFocus: false
	},
	dropdownWidth: "auto" as const,
	responsiveMode: 999,
	styles: {
		callout: {
			maxHeight: '60vh',
			minWidth: '300px',
			width: 'auto',
			backgroundColor: '#ffffff',
			selectors: {
				'.ms-Callout-main': {
					maxHeight: '60vh',
					minWidth: '300px',
					overflow: 'auto' as 'auto',
					backgroundColor: '#ffffff',
					scrollBehavior: 'auto' as 'auto'
				}
			}
		},
		dropdownItemsWrapper: {
			maxHeight: '50vh',
			minWidth: '300px',
			backgroundColor: '#ffffff',
			scrollBehavior: 'auto' as 'auto'
		},
		dropdownItems: {
			minWidth: '300px',
			backgroundColor: '#ffffff'
		},
		dropdownItem: {
			backgroundColor: '#ffffff',
			minWidth: '300px',
			whiteSpace: 'normal',
			height: 'auto',
			lineHeight: '20px',
			padding: '8px'
		},
		dropdownItemSelected: {
			backgroundColor: '#f3f2f1',
			minWidth: '300px'
		},
		dropdownItemSelectedAndDisabled: {
			backgroundColor: '#f3f2f1',
			minWidth: '300px'
		}
	}
};

export interface AppProps {
   hide: boolean;
   data: any;
}

export interface AppState {
    task_subtypes: any,
    subject: string,
    selectedType: string,
    selectedSubType: string,
    selectedStatus: string,
    invalid_subject: string,
    selectedAssignee: any
}

class NewTaskProperties extends React.Component<AppProps, AppState> {
    private originalScrollIntoView: any;

    constructor(props) {
        super(props);

        this.handleSubjectChange = this.handleSubjectChange.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleSubTypeChange = this.handleSubTypeChange.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handleAssigneeChange = this.handleAssigneeChange.bind(this);
        this.searchAssignee = this.searchAssignee.bind(this);
        this.get_task_type();
        this.get_task_sub_type();
        this.get_task_status();
        
        // Disable auto-scroll on hover in dropdowns by overriding scrollIntoView
        this.disableAutoScrollInDropdowns();
        
        // Prevent focus changes on hover
        this.preventDropdownFocusOnHover();

        this.state = {
            task_subtypes: task_subtypes,
            subject: (Office.context.mailbox ? Office.context.mailbox.item.subject.replace(/[*|?:"<>\\\  /]/gi, ' ') : ''),
            selectedType: GetSetting('task_type_default', null),
            selectedSubType: GetSetting('task_subtype_depend_default', null),
            selectedStatus: GetSetting('task_status_default', null),
            invalid_subject: 'Invalid Subject please re-enter',
            selectedAssignee: null
        };
    }

    handleSubjectChange = (_event, item) => {
        sessionStorage.setItem('subject', item);
        this.setState({subject: item});
    }

    handleTypeChange = (_event, item) => {
        let data: any;
        sessionStorage.setItem('task_type', JSON.stringify({ id: item.key, name: item.text }));
        get_choice_field_dependence(group_name, 'subtype', '');
        task_subtypes = [{ key: 'Header', text: 'Task Subtype', itemType: DropdownMenuItemType.Header }];

        data = JSON.parse(localStorage.getItem(group_name + '_subtype_results')) || [];

        const type_depends = JSON.parse(localStorage.getItem(group_name + '_subtype_depend_results')) || '';
        if (type_depends?.choice_category_dependence) {
            const cat_types = type_depends.choice_category_dependence;

            if ((cat_types !== null) && (cat_types[item.key] !== null && cat_types[item.key] !== undefined)) {
                let sub_types = cat_types[item.key];

                for (let i = 0; i < sub_types.length; i++) {
                    let fld_sub_type = sub_types[i];
                    let objType = this.ArrayToObject(data);
                    task_subtypes.push({ key: fld_sub_type, text: objType[fld_sub_type], itemType: DropdownMenuItemType.Normal });
                }
            }
        } else {
            this.get_task_sub_type();
        }

        this.setState({task_subtypes: task_subtypes, selectedType: item.key});
    }

    handleSubTypeChange = (_event, item) => {
        sessionStorage.setItem('task_subtype', JSON.stringify({id: item.key, name: item.text}));
        this.setState({selectedSubType: item.key});
    }

    handleStatusChange = (_event, item) => {
        sessionStorage.setItem('task_status', JSON.stringify({id: item.key, name: item.text}));
        this.setState({selectedStatus: item.key});
    }

    handleAssigneeChange = (selectedOption: any) => {
        console.log('[NewTaskProperties] handleAssigneeChange called with option:', selectedOption);
        if (selectedOption) {
            const assigneeData = {id: selectedOption.value, name: selectedOption.label};
            console.log('[NewTaskProperties] Setting task_assignee to:', assigneeData);
            sessionStorage.setItem('task_assignee', JSON.stringify(assigneeData));
            this.setState({selectedAssignee: selectedOption});
            
            // Verify it was stored correctly
            const stored = sessionStorage.getItem('task_assignee');
            console.log('[NewTaskProperties] Verified storage:', stored);
        } else {
            // User cleared the selection
            console.log('[NewTaskProperties] Clearing assignee selection');
            sessionStorage.removeItem('task_assignee');
            this.setState({selectedAssignee: null});
        }
    }

    searchAssignee = async (text: string): Promise<any[]> => {
        // Require minimum 3 characters
        if (!text || text.length < 3) {
            return [];
        }

        try {
            console.log('[NewTaskProperties] Searching for assignee:', text);
            // Search for users - entity type 'user'
            const results = await entity_quick_search({ entityName: text }, 'user', []);
            console.log('[NewTaskProperties] Search results:', results);
            
            const options = results.map(user => ({
                value: user.id,
                label: user.entity_name || user.name || `User ${user.id}`,
                user_name: user.entity_name || user.name
            }));

            console.log('[NewTaskProperties] Formatted options:', options);
            return options;
        } catch (error) {
            console.error('[NewTaskProperties] Error searching assignees:', error);
            return [];
        }
    }

    summary = () => {
        toggleLoading(false);
        summaryScreen();
    }

    disableNext = (): boolean => {
        let count = 0;
        if (this.state.selectedType !== null) {// 0 is allowed
            if (this.state.selectedType.toString().length > 0) {
                count = count + 1;
            }
        }
        if (this.state.selectedStatus !== null) {// 0 is allowed
            if (this.state.selectedStatus.toString().length > 0) {
                count = count + 1;
            }
        }
        if (this.ValidateSubject()) {
            count = count + 1;
        }
        return count !== 3;
    }

    get_task_type = () => {
        let data: any;
        task_types = [{ key: 'Header', text: 'Task Type', itemType: DropdownMenuItemType.Header }];

        data = JSON.parse(localStorage.getItem(group_name + '_taskkind_results')) || [];
        if (data && data.length > 0) {
            for (let i = 0; i < data.length; i++) {
                task_types.push({ key: data[i][0], text: data[i][1], itemType: DropdownMenuItemType.Normal });
            }
        } else if (localStorage.getItem("ufields_need_loading") === "true") {
            // Data is still loading
            task_types.push({ key: 'loading', text: 'Loading options...', itemType: DropdownMenuItemType.Normal });
        }
    }

    get_task_sub_type = () => {
        let data: any;
        task_subtypes = [{ key: 'Header', text: 'Task Sub Type', itemType: DropdownMenuItemType.Header }];

        data = JSON.parse(localStorage.getItem(group_name + '_subtype_results')) || [];
        if (data && data.length > 0) {
            for (let i = 0; i < data.length; i++) {
                task_subtypes.push({ key: data[i][0], text: data[i][1], itemType: DropdownMenuItemType.Normal });
            }
        } else if (localStorage.getItem("ufields_need_loading") === "true") {
            // Data is still loading
            task_subtypes.push({ key: 'loading', text: 'Loading options...', itemType: DropdownMenuItemType.Normal });
        }
    }

    get_task_status = () => {
        let data: any;
        task_status = [{ key: 'Header', text: 'Task Status', itemType: DropdownMenuItemType.Header }];

        data = JSON.parse(localStorage.getItem(group_name + '_status_results')) || [];
        if (data && data.length > 0) {
            for (let i = 0; i < data.length; i++) {
                task_status.push({ key: data[i][0], text: data[i][1], itemType: DropdownMenuItemType.Normal });
            }
        } else if (localStorage.getItem("ufields_need_loading") === "true") {
            // Data is still loading
            task_status.push({ key: 'loading', text: 'Loading options...', itemType: DropdownMenuItemType.Normal });
        }
    }

    disableAutoScrollInDropdowns = () => {
        // Save original scrollIntoView
        this.originalScrollIntoView = Element.prototype.scrollIntoView;
        
        // Override scrollIntoView to prevent auto-scrolling on hover
        Element.prototype.scrollIntoView = function(arg?: any) {
            // Check if element is inside a dropdown or callout
            if (this.closest) {
                const inDropdown = this.closest('.ms-Dropdown-items') || 
                                 this.closest('.ms-Dropdown-itemsWrapper') ||
                                 this.closest('.ms-Callout-main') ||
                                 this.closest('.ms-Dropdown-callout') ||
                                 this.classList?.contains('ms-Dropdown-item');
                
                if (inDropdown) {
                    // Block ALL scrollIntoView calls inside dropdowns
                    return;
                }
            }
            // Allow scrollIntoView for other cases
            return this.originalScrollIntoView.call(this, arg);
        };
    }

    restoreScrollIntoView = () => {
        if (this.originalScrollIntoView) {
            Element.prototype.scrollIntoView = this.originalScrollIntoView;
        }
    }

    preventDropdownFocusOnHover = () => {
        // Add event listener to prevent focus on hover in dropdowns
        document.addEventListener('mousemove', (e) => {
            const target = e.target as HTMLElement;
            if (target && typeof target.closest === 'function') {
                const dropdownItem = target.closest('.ms-Dropdown-item');
                if (dropdownItem) {
                    // Prevent focus by stopping the event
                    e.stopPropagation();
                    // Remove focus from the item if it has it
                    const focusedElement = document.activeElement as HTMLElement;
                    if (focusedElement && focusedElement.closest('.ms-Dropdown-item')) {
                        focusedElement.blur();
                    }
                }
            }
        }, true);
    }

    public ArrayToObject = (array: any[]): any => {
        let object = {};
        array.forEach(element => {
            object[element[0]] = element[1];
        });
        return object;
    }

    private ValidateSubject = (): boolean => {
        if (!this.state.subject) {
            throwError(this.state.invalid_subject);
            return false;
        }
        clearError();
        return true;
    }

    componentDidMount() {
        if (this.state.selectedSubType) {
          this.get_task_sub_type();
          this.setState({task_subtypes: task_subtypes});
          const text = GetItemText(group_name + '_subtype_results', this.state.selectedSubType);
          sessionStorage.setItem('task_subtype', JSON.stringify({id: this.state.selectedSubType, name: text}));
        }
        if (this.state.selectedType) {
            const text = GetItemText(group_name + '_taskkind_results', this.state.selectedType);
            sessionStorage.setItem('task_type', JSON.stringify({ id: this.state.selectedType, name: text }));
        }
        if (this.state.selectedStatus) {
            const text = GetItemText('task_status_results', this.state.selectedStatus);
            sessionStorage.setItem('task_status', JSON.stringify({id: this.state.selectedStatus, name: text}));
        }
        if (this.state.subject) {
            sessionStorage.setItem('subject', this.state.subject);
        }
    }

    componentWillUnmount() {
        // Restore original scrollIntoView behavior
        this.restoreScrollIntoView();
    }

    public render() {

        if (this.props.hide) {
            return(null);
        }
        return (
            <div style={{ fontSize: '13px' }}>
                <div style={{ marginBottom: '4px' }}>
                    <TextField
                        label='Task Subject'
                        placeholder='Subject'
                        onChange={this.handleSubjectChange}
                        value={this.state.subject}
                        styles={{ 
                            fieldGroup: { height: '32px', borderColor: '#5D3FD6', borderRadius: '6px' },
                            field: { fontSize: '13px' },
                            subComponentStyles: {
                                label: { root: { fontSize: '12px', fontWeight: 500, color: '#1A1F4D', marginBottom: '3px' } }
                            }
                        }}/>
                </div>
                <div style={{ marginBottom: '4px' }}>
                    <Dropdown
                        label='* Task Type'
                        placeholder='Type'
                        onChange={this.handleTypeChange}
                        options={task_types}
                        defaultSelectedKey={this.state.selectedType ? Number(this.state.selectedType) : null}
                        calloutProps={responsiveDropdownProps.calloutProps}
                        dropdownWidth={responsiveDropdownProps.dropdownWidth}
                        responsiveMode={responsiveDropdownProps.responsiveMode}
                        styles={{
                            label: { fontSize: '12px', fontWeight: 500, color: '#1A1F4D', marginBottom: '3px' },
                            title: { fontSize: '13px', height: '32px', lineHeight: '28px', borderColor: '#5D3FD6', borderRadius: '6px' },
                            ...responsiveDropdownProps.styles
                        }}
                    />
                </div>
                <div style={{ marginBottom: '4px' }}>
                    <Dropdown
                        label='Task Sub Type'
                        placeholder='Subtype'
                        id='taskSubType'
                        onChange={this.handleSubTypeChange}
                        options={this.state.task_subtypes}
                        disabled={this.state.task_subtypes.length < 2}
                        defaultSelectedKey={this.state.selectedType ? Number(this.state.selectedSubType) : null}
                        calloutProps={responsiveDropdownProps.calloutProps}
                        dropdownWidth={responsiveDropdownProps.dropdownWidth}
                        responsiveMode={responsiveDropdownProps.responsiveMode}
                        styles={{
                            label: { fontSize: '12px', fontWeight: 500, color: '#1A1F4D', marginBottom: '3px' },
                            title: { fontSize: '13px', height: '32px', lineHeight: '28px', borderColor: '#5D3FD6', borderRadius: '6px' },
                            ...responsiveDropdownProps.styles
                        }}
                    />
                </div>
                <div style={{ marginBottom: '4px' }}>
                    <Dropdown
                        label='* Task Status'
                        placeholder='Status'
                        onChange={this.handleStatusChange}
                        options={task_status}
                        defaultSelectedKey={Number(this.state.selectedStatus)}
                        calloutProps={responsiveDropdownProps.calloutProps}
                        dropdownWidth={responsiveDropdownProps.dropdownWidth}
                        responsiveMode={responsiveDropdownProps.responsiveMode}
                        styles={{
                            label: { fontSize: '12px', fontWeight: 500, color: '#1A1F4D', marginBottom: '3px' },
                            title: { fontSize: '13px', height: '32px', lineHeight: '28px', borderColor: '#5D3FD6', borderRadius: '6px' },
                            ...responsiveDropdownProps.styles
                        }}
                    />
                </div>
                <div style={{ marginBottom: '4px' }}>
                    <Label styles={{ 
                        root: {
                            display: 'block',
                            fontSize: '12px',
                            fontWeight: 500,
                            color: '#1A1F4D',
                            marginBottom: '3px',
                            padding: 0
                        }
                    }}>
                        Assignee (leave blank to assign to yourself)
                    </Label>
                    <AsyncSelect
                        cacheOptions={false}
                        loadOptions={this.searchAssignee}
                        onChange={this.handleAssigneeChange}
                        value={this.state.selectedAssignee}
                        isClearable={true}
                        placeholder='Type to search for a user (min 3 characters)'
                        noOptionsMessage={(obj) => obj.inputValue.length < 3 ? "Type at least 3 characters" : "No users found"}
                        loadingMessage={() => "Searching..."}
                        blurInputOnSelect={true}
                        styles={{
                            control: (base) => ({
                                ...base,
                                minHeight: '32px',
                                fontSize: '13px',
                                borderColor: '#5D3FD6',
                                borderWidth: '1px',
                                borderRadius: '6px',
                                '&:hover': {
                                    borderColor: '#5D3FD6'
                                }
                            }),
                            valueContainer: (base) => ({
                                ...base,
                                padding: '2px 6px'
                            }),
                            menu: (base) => ({
                                ...base,
                                zIndex: 9999,
                                fontSize: '13px'
                            }),
                            option: (base) => ({
                                ...base,
                                fontSize: '13px'
                            }),
                            singleValue: (base) => ({
                                ...base,
                                fontSize: '13px',
                                color: '#1A1F4D'
                            })
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default NewTaskProperties;
